export class FoodModel {
  constructor(
    public id: number,
    public name: string,
    public servingSize: number,
    public unitsOfMeasureId: number,
    public carbs: number,
    public alcohol: number,
    public fiber: number,
    public netcarbs: number,
    public fat: number,
    public protein: number,
    public calories: number
  ) { }
}
